import { Skill } from './types';
import styles from './Skills.module.scss';

const SatelliteCard = ({ skill }: { skill: Skill }) => (
  <>
    <h3 className={styles.name}>{skill.name}</h3>
    <div className={styles.barMeta}>
      <span className={styles.barLabel}>{skill.level}%</span>
      <div className={styles.barTrack}>
        <div className={styles.barFill} />
      </div>
    </div>
  </>
);

export default SatelliteCard;
